import { makeStyles } from '@mui/styles';

const useEditGroupGroupsStyles = makeStyles({
	th: {
		fontFamily: 'Montserrat',
		color: '#003C82',
		fontWeight: 'bold',
		textAlign: 'left',
		fontSize: '12px',
	},
	td: {
		color: '#1A1233',
		fontFamily: 'Montserrat',
		fontWeight: '500',
		fontSize: '12px',
		padding: '0',
	},
	table: {
		width: '100%',
		margin: 'auto',
		borderCollapse: 'collapse',
	},
	tr: {
		borderBottom: '1px solid #00000029',
		height: 45.37,
	},
	tooltip: {
		fontSize: '10px !important',
		fontFamily: 'Montserrat, Medium',
		backgroundColor: '#686868 !important',
		color: 'white !important',
		borderRadius: '10px !important',
		width: 'auto',
		textAlign: 'center',
		padding: '4px 12px !important',
		marginTop: '-5px !important',
	},
	arrow: {
		color: 'white !important',
	},
	ulClients: {
		listStyle: 'none',
		color: '#707070',
		fontSize: 16,
		padding: 0,
		width: '90%',
		margin: '4% auto',
	},
	liClients: {
		cursor: 'pointer',
	},
	divList: {
		padding: 1,
		position: 'relative',
		background: 'white',
		zIndex: '1',
		boxShadow: '0px 3px 6px #00000029',
		width: '87%',
		borderBottomLeftRadius: '6px !important',
		borderBottomRightRadius: '6px !important',
	},
	textField: {
		color: '#707070',
	},
});

export default useEditGroupGroupsStyles;
